import { useState, useEffect } from "react";
import permissionGroupIcon from "../../assets/icons/mangment icons/PermissionGroup.png";
import adminIcon from "../../assets/icons/mangment icons/admin.png";
import {
  deleteDataToken,
  getData,
  patchDataToken,
  postData,
} from "../../axios/axiosHelper";
import { toastMsg } from "../../functions/toastMsg";
import { ADMIN_PAGE_LABELS } from "../../navigation/adminNavigation";

const AdminsHook = () => {
  const [loading, setLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [blockLoading, setBlockLoading] = useState({});
  const [deleteLoading, setDeleteLoading] = useState({});
  const [resendLoading, setResendLoading] = useState({});

  
  const [admins, setAdmins] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const perPage = 10;
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [permissionGroup, setPermissionGroup] = useState([]);

  const [selectedTeamId, setSelectedTeamId] = useState(null);
  const [selectedTeamName, setSelectedTeamName] = useState(null);
  const handleSelect = (teamId) => {
    const selectedTeam = permissionGroup.find((team) => team._id === teamId);
    setSelectedTeamId(teamId);
    setSelectedTeamName(selectedTeam.name);
    setFormData({ ...formData, permissionGroup: teamId });
  };
  const teams = [
    { id: 1, name: "Team A", nameAr: "فريق ب" },
    { id: 2, name: "Team B", nameAr: "فريق ب" },
    { id: 3, name: "Team C", nameAr: "فريق ب" },
  ];

  const [search, setSearch] = useState(false);
  useEffect(() => {
    setLoading(true);
    let queryParams = `/permissionGroup`;

    getData(queryParams, true)
      .then((res) => {
        setPermissionGroup(res.data.data);
      })
      .catch((err) => toastMsg(err.response.data.message, "error"))
      .finally(() => setLoading(false));
  }, []);
  const NavItems = [
    {
      name: ADMIN_PAGE_LABELS.roles,
      to: "/management/permissiongroup",
      icon: permissionGroupIcon,
    },
    {
      name: ADMIN_PAGE_LABELS.admins,
      to: "/management/admins",
      icon: adminIcon,
    },
  ];

  useEffect(() => {
    setLoading(true);
    let queryParams = `/admin?page=${currentPage}&perPage=${perPage}`;

    if (search) {
      queryParams += `&search=${encodeURIComponent(search)}`;
    }

    getData(queryParams, true)
      .then((res) => {
        setAdmins(res.data.data);
        setTotalPages(res.data.pagination.totalPages);
      })
      .catch((err) => toastMsg(err.response.data.message, "error"))
      .finally(() => setLoading(false));
  }, [currentPage, perPage, search]);
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentAdminId, setCurrentAdminId] = useState(null); // To track the admin being edited

  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    permissionGroup: selectedTeamId ? selectedTeamId : "",
  };

  const [formData, setFormData] = useState(initialValues);

  const handleEditAdmin = (adminId) => {
    setIsEditMode(true);
    setCurrentAdminId(adminId); // Store the ID of the admin being edited
    handleShow();

    // Load the existing admin's data into formData if needed
    const adminToEdit = admins.find((admin) => admin._id === adminId);
    if (adminToEdit) {
      setFormData({
        firstName: adminToEdit.firstName,
        lastName: adminToEdit.lastName,
        email: adminToEdit.email,
        permissionGroup: adminToEdit.permissionGroup?._id || "",
      });
    }
  };

  const handleAddNewAdmin = () => {
    setIsEditMode(false);
    setFormData(initialValues); // Reset the form data
    handleShow();
  };

  const handleSubmit = () => {
    setAddLoading(true);

    if (isEditMode && currentAdminId) {
      // Editing mode: Use patchDataToken
      const dataToSend = { permissionGroup: formData.permissionGroup };

      patchDataToken(`/admin/${currentAdminId}`, dataToSend, true)
        .then((res) => {
          toastMsg(res.data?.message, "success");
          setAdmins((prev) =>
            prev.map((admin) =>
              admin._id === currentAdminId
                ? { ...admin, ...res.data.data }
                : admin
            )
          );
          setFormData(initialValues);
          handleClose();
        })
        .catch((err) => toastMsg(err.response.data?.message))
        .finally(() => setAddLoading(false));
    } else {
      // Creating mode: Use postData
      postData("/admin", formData, true)
        .then((res) => {
          toastMsg(res.data?.message, "success");
          setAdmins((prev) => [...prev, res.data.data]);
          setFormData(initialValues);
          handleClose();
        })
        .catch((err) => toastMsg(err.response.data?.message))
        .finally(() => setAddLoading(false));
    }
  };

  const handleDelete = (adminId) => {
    setDeleteLoading((prevState) => ({ ...prevState, [adminId]: true }));

    deleteDataToken(`/admin/${adminId}`, true)
      .then((res) => {
        toastMsg(res.data?.message, "success");
        setAdmins((prev) => prev.filter((pr) => pr._id !== adminId));
      })
      .catch((err) => toastMsg(err.response.data?.message))  
      .finally(() => {
        setDeleteLoading((prevState) => ({ ...prevState, [adminId]: false }));
      });
  };
  const handleBlock = (adminId) => {
    setBlockLoading((prevState) => ({ ...prevState, [adminId]: true }));

    patchDataToken(`/admin/toggleIsBlockedState/${adminId}`, true)
      .then((res) => {
        toastMsg(res.data?.message, "success");
        setAdmins((prevAdmins) =>
          prevAdmins.map((admin) =>
            admin._id === adminId
              ? { ...admin, isBlocked: !admin.isBlocked }
              : admin
          )
        );
      })
      .catch((err) => toastMsg(err.response.data?.message))
      .finally(() => {
        setBlockLoading((prevState) => ({ ...prevState, [adminId]: false }));
      });
  };

  const handleResendInvitation = async (adminId) => {
    setResendLoading((current) => ({ ...current, [adminId]: true }));
    try {
      const response = await postData(
        `/admin/${adminId}/resend-invitation`,
        {},
        true
      );
      toastMsg(response.data?.message || "Admin invitation sent", "success");
    } catch (error) {
      toastMsg(
        error?.response?.data?.message || "Invitation could not be sent",
        "error"
      );
    } finally {
      setResendLoading((current) => ({ ...current, [adminId]: false }));
    }
  };

  return {
    NavItems,
    setSearch,
    handleShow,
    teams,
    show,
    handleClose,
    handleSelect,
    selectedTeamName,
    handleNextPage,
    handlePrevPage,
    totalPages,
    currentPage,
    admins,
    loading,
    permissionGroup,
    handleSubmit,
    formData,
    setFormData,
    handleBlock,
    handleDelete,
    handleEditAdmin,
    handleAddNewAdmin,
    isEditMode,
    addLoading,
    blockLoading,
    deleteLoading,
    handleResendInvitation,
    resendLoading
  };
};

export default AdminsHook;
